import React from "react";
import { FormOptionGroup } from "mesh-component-library";
import { useLocale } from "../../contexts/LocaleContext";
import { TRANSLATION_CONSTANTS } from "../../app-consts/translations";

type HelpWithtransportation = {
  onChange: (e: React.FormEvent<HTMLFieldSetElement>) => void;
  response: string;
};

export const HelpWithtransportation = ({ onChange, response }: HelpWithtransportation) => {
 const getTranslatedText = useLocale();

 return (
  <FormOptionGroup
    label= {getTranslatedText(TRANSLATION_CONSTANTS.NEED_HELP_WITH_TRANSPORTATION)}
    onChange={onChange}
    options={[
      {
        id: "transport-option-1",
        name: "transport-options",
        text: "Yes",
        value: "Yes",
        defaultChecked: "Yes" === response,
      },
      {
        id: "transport-option-2",
        name: "transport-options",
        text: "No",
        value: "No",
        defaultChecked: "No" === response,
      },
    ]}
    type="radio"
    required={true}
  />
)
};